export default __webpack_public_path__ + "assets/media-5aabadc0b85bc70165aa6a499a793054.svg";